import { render, staticRenderFns } from "./EvtoolsTour.vue?vue&type=template&id=31cb2c88"
import script from "./EvtoolsTour.vue?vue&type=script&lang=js"
export * from "./EvtoolsTour.vue?vue&type=script&lang=js"
import style0 from "./EvtoolsTour.vue?vue&type=style&index=0&id=31cb2c88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports